import React from "react";
import "../../styles/ServicePages.css";

const InsurancePage = () => {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <div className="service-hero">
        <h1>🛡️ Cargo Insurance Solutions</h1>
        <p>Comprehensive protection for your shipments across all modes of transport with customizable coverage</p>
      </div>

      {/* Main Content */}
      <div className="service-content">
        {/* Overview */}
        <section className="overview-section">
          <h2>Protection You Can Trust</h2>
          <p className="overview-text">
            AROCL's insurance solutions protect your valuable cargo against unforeseen losses. 
            We offer comprehensive marine, air, road, and rail coverage with flexible policies tailored to your shipment requirements.
          </p>
        </section>

        {/* Features Grid */}
        <section className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">🌊</span>
            <h3>Marine Insurance</h3>
            <p>Full coverage for sea shipments including cargo, vessels, and liability</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">✈️</span>
            <h3>Air Cargo Insurance</h3>
            <p>Specialized coverage for air freight with rapid claims settlement</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🚚</span>
            <h3>Land Transport Insurance</h3>
            <p>Comprehensive road and rail cargo coverage nationwide</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔄</span>
            <h3>All-Risk Policies</h3>
            <p>Complete protection against loss or damage from any cause</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📋</span>
            <h3>Named Perils Coverage</h3>
            <p>Customized policies covering specific identified risks</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">⚡</span>
            <h3>Quick Claims Settlement</h3>
            <p>Fast processing and hassle-free claim management support</p>
          </div>
        </section>

        {/* Benefits Section */}
        <section className="benefits-section">
          <h2>Insurance Coverage Benefits</h2>
          <div className="benefits-list">
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Financial Protection</h4>
                <p>Safeguard your investment against loss, theft, or damage</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Flexible Coverage</h4>
                <p>Customize policies based on cargo value and shipment type</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Global Recognition</h4>
                <p>Policies accepted worldwide with international credibility</p>
              </div>
            </div>
            <div className="benefit-item">
              <span className="benefit-check">✅</span>
              <div className="benefit-text">
                <h4>Expert Support</h4>
                <p>Dedicated claim handlers and insurance professionals</p>
              </div>
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="process-section">
          <h2>Insurance Process</h2>
          <div className="process-timeline">
            <div className="process-step">
              <div className="step-number">1</div>
              <h3>Coverage Assessment</h3>
              <p>Evaluate cargo type, value, route, and risk factors</p>
            </div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h3>Policy Issuance</h3>
              <p>Create customized insurance policy matching your needs</p>
            </div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h3>Shipment Monitoring</h3>
              <p>Track shipment and ensure compliance with policy terms</p>
            </div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h3>Claim Settlement</h3>
              <p>Process claims promptly with documentation support</p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="stats-section">
          <div className="stat-card">
            <div className="stat-number">$500M+</div>
            <div className="stat-label">Coverage Value</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">95%</div>
            <div className="stat-label">Claim Approval</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">24hrs</div>
            <div className="stat-label">Claim Processing</div>
          </div>
          <div className="stat-card">
            <div className="stat-number">20+</div>
            <div className="stat-label">Insurance Partners</div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <h2>Protect Your Cargo Today</h2>
          <p>Get comprehensive insurance coverage for your valuable shipments with AROCL's trusted insurance solutions.</p>
          <div className="cta-buttons">
            <button className="cta-btn cta-btn-primary" onClick={() => window.location.href = "tel:+919876543210"}>📞 Call Now</button>
            <button className="cta-btn cta-btn-secondary" onClick={() => window.location.href = "https://wa.me/919876543210?text=I need cargo insurance for my shipment."}>💬 Chat on WhatsApp</button>
          </div>
        </section>
      </div>
    </div>
  );
};

export default InsurancePage;
